module.exports = __webpack_public_path__ + "static/media/report_3.afb9c422.png";